module.exports = __webpack_public_path__ + "static/bckg-ff1099e98ec8ed3b520640ee13c460fb.png";